import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { User } from 'models/user';
import { Organization } from 'models/organization';

type DentistSummaryProps = {
    dentist?: Partial<User>;
    clinic?: Partial<Organization>;
};
const DentistSummary: FC<DentistSummaryProps> = ({ dentist, clinic }) => {
    const { t: translate } = useTranslation(['common', 'orders']);

    return (
        <Fragment>
            {dentist && clinic ? (
                <Fragment>
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:CLINIC')}:</Typography>
                        </Box>
                        <Box>{clinic.name}</Box>
                    </Box>
                    <Box display="flex">
                        <Box mr={1}>
                            <Typography variant="subtitle2">{translate('orders:DENTIST')}:</Typography>
                        </Box>
                        <Box>{dentist.fullName}</Box>
                    </Box>
                </Fragment>
            ) : undefined}
        </Fragment>
    );
};

export default DentistSummary;
